import httpClient from "@/apis/base/axios-httpclient";
import api from "@/apis/AssetBalanceAPI";
import Crud from "./crud-base";
import apiAssetBalanceAPI from "@/apis/AssetBalanceAPI";
var crud = new Crud("AssetBalance", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "AssetKeyID",
      code: "",
      name: "",
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,

  /**
   * Lấy danh sách các tài sản cấp phát theo số lượng
   * @param {} context
   * @param {*} payload
   * @returns
   */
  getAssetBalanceFullFieldByAssetID: async function (context, payload) {
    context.commit("updateLoading", true);
    let res = await apiAssetBalanceAPI.getAssetBalanceFullFieldByAssetID(payload);
    context.commit("updateLoading", false);
    if (res) {
      return res;
    }
  },

  getAssetBalanceTotalByAssetID: async function (context, payload) {
    let res = await apiAssetBalanceAPI.getAssetBalanceTotalByAssetID(payload);
    if (res) return res;
    else return null;
  },
  getAssetBalanceFullFieldByAssetStatus: async function (context, payload) {
    let res = await apiAssetBalanceAPI.getAssetBalanceFullFieldByAssetStatus(payload);
    if (res) return res;
    else return null;
  },
  getAssetBalanceTotalByAssetIDForQuantity: async function (context, payload) {
    let res = await apiAssetBalanceAPI.getAssetBalanceTotalByAssetIDForQuantity(payload);
    if (res) return res;
    else return null;
  },
  getAssetBalanceTotalByListAssetID: async function (context, payload) {
    let res = await apiAssetBalanceAPI.getAssetBalanceTotalByListAssetID(payload);
    if (res) return res;
    else return null;
  },
  getAssetBalanceFullFieldByListAssetID: async function (context, payload) {
    let res = await apiAssetBalanceAPI.getAssetBalanceFullFieldByListAssetID(payload);
    if (res) return res;
    else return null;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
